import { IApplicationState } from '../../types/redux';

export function getBuilders(state: IApplicationState) {
  const {
    newbuildingInfo: { builders },
  } = state;

  if (builders) {
    return builders;
  }

  return [];
}
